import * as React from 'react';
import { ProtectedPageWrapper } from '../designSystem/layouts/pageWrappers/ProtectedPageWrapper';
import { useState } from 'react';
import { DashboardPageLayout } from '../designSystem/layouts/SingleColumnLayout';
import { Card } from '../designSystem/Card';
import styled from 'styled-components';
import { ActivityTimeLine } from '../features/overview/ActivityTimeline';
import { PageHeader } from '../designSystem/PageHeader';
import { tablet } from '../designSystem/BreakPoints';
import { DeviceView } from '../designSystem/DeviceView';
import { UserNotification, UserToken } from '../amorg-common';
import { getMaybeActiveUserOrRefresh } from '../api/serverApiHelpers';
import { getUserNotifications } from '../api/notificationClientApi';
import { H3 } from '../designSystem/typography/Heading';
import { P } from '../designSystem/typography/Body';
import { DashboardCard } from './dashboard/_components/DashboardCard';
import DashboardComponents from './dashboard/DashboardComponents';
import { DashboardFactCard } from './dashboard/_components/DashboardFactCard';


export default function DashboardPage(): JSX.Element {

    const [startDate,] = useState(new Date());
    const [user, setUser] = useState<UserToken | null>(null);

    React.useState(()=>{
        const getData = async ()=>{
            const usr = await getMaybeActiveUserOrRefresh();
            if(usr.hasAccess)
                setUser(usr.tokenUser);
        };
        getData();
    })

    const sharedTimeline = 
        <TimelineDashGrid>
            <Card variant="outlined">
                <ActivityTimeLine yearMonthStart={startDate} />
            </Card>
        </TimelineDashGrid>


    return (
        <ProtectedPageWrapper requiredPermissions={['ViewNotifications']} selectedMenuItemKey='dashboard'>
            {user && 
            <DashboardPageLayout
                headerContainer={<PageHeader headerIcon='navigation_map' headerText="Overblik" headerStyle='secondary-gray' />}
                noDivider
                contentContainer={
                    <DashboardLayout>
                        <DeviceView
                            tablet={sharedTimeline}
                            desktop={sharedTimeline} />

                            <CallToActionGrid>
                                <NotificationCard />
                                <DashboardFactCard />
                            </CallToActionGrid>
                            
                            <DashboardComponents />
                            
                        </DashboardLayout>
                    } />
            }
        </ProtectedPageWrapper>
    )
}


function NotificationCard(): JSX.Element {

    const [notifications, setNotifications] = React.useState<UserNotification[]>([]);

    React.useEffect(()=>{
            const getData = async ()=>{
                const user = await getMaybeActiveUserOrRefresh([]);
                const notifs = await getUserNotifications(user.tokenUser.userId, false, false);
                setNotifications(notifs);
            };
            getData();
        }, []);



    return (
        <DashboardCard shadow backgroundIcon="assignment_late" redirectTo={"/notifications"}>
            <H3>Notifikationer</H3>
            <P>Der ligger {notifications.length} notifikation{notifications.length !== 1 ? "er" : ""}</P>
        </DashboardCard>
    );
}


const DashboardLayout = styled.div`
    display: grid;
    grid-template-areas:
        'timeline timeline callToAction'
        'feature feature feature';
    
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto 1fr;
    gap: 24px;

    /* Place the third child (DashboardComponents in your JSX) into the feature area
       without changing DashboardComponents itself. */
    & > :nth-child(3) {
        grid-column: 1 / -1;
        grid-area: feature;
    }

    @media(max-width: ${tablet}px){
        grid-template-columns: 1fr;
        grid-template-rows: auto auto 1fr;

        grid-template-areas:
            'timeline'
            'callToAction'
            'feature'
        ;

        & > :nth-child(3) {
            grid-column: auto;
            grid-area: feature;
        }
    }
`;

const TimelineDashGrid = styled.div`
    display: grid;
    grid-area: timeline;
`;

const CallToActionGrid = styled.div`
    display: grid;
    grid-area: callToAction;
    grid-template-rows: min-content 1fr;
    gap: 24px;

    @media(max-width: ${tablet}px){
        grid-template-columns: 1fr;
        grid-template-rows: 1fr 1fr 2fr;
    }
`;